export default __webpack_public_path__ + "static/media/red.29800096.png";